import { map, filter } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
// utils
import { axiosInstance as axios } from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  data: [],
  meta: null,
  params: {
    page: 1,
    active: true,
    deleted: false,
  },
  record: null,
};

const slice = createSlice({
  name: 'categoryProduct',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET CATEGORYPRODUCTS
    getCategoryProductsSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload.results;
      state.meta = action.payload.meta;
      state.error = false;
    },

    // GET CATEGORYPRODUCT
    getCategoryProductSuccess(state, action) {
      state.isLoading = false;
      state.record = action.payload;
      state.error = false;
    },

    // CREATE CATEGORYPRODUCT
    createCategoryProductSuccess(state, action) {
      const record = action.payload;
      state.isLoading = false;
      state.data = [...state.data, record];
      state.error = false;
    },

    // UPDATE CATEGORYPRODUCT
    updateCategoryProductSuccess(state, action) {
      state.record = action.payload;
      const updateRecord = map(state.data, (_record) => {
        if (_record.id === state.record.id) {
          return state.record;
        }
        return _record;
      });

      state.isLoading = false;
      state.data = updateRecord;
      state.params = { ...state.params };
      state.error = false;
    },

    // DELETE CATEGORYPRODUCT
    deleteCategoryProductSuccess(state, action) {
      const { id } = action.payload;
      const deleteRecord = filter(state.data, (user) => user.id !== id);
      state.isLoading = false;
      state.data = deleteRecord;
      state.error = false;
    },

    // SET PARAMS
    setParams(state, action) {
      state.params = action.payload;
    },

    // REFRESH PARAMS
    refreshParams(state) {
      state.params = { ...state.params };
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { setParams, refreshParams } = slice.actions;

// ----------------------------------------------------------------------

export function getCategoryProducts(params = {}) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/category-product/', {
        params,
      });
      dispatch(slice.actions.getCategoryProductsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getCategoryProduct(id) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/category-product/${id}/`);
      dispatch(slice.actions.getCategoryProductSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function createCategoryProduct(record) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/category-product/', record);
      dispatch(slice.actions.createCategoryProductSuccess(response.data));
      return response.data;
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

// ----------------------------------------------------------------------

export function updateCategoryProduct(id, record) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.put(`/category-product/${id}/`, record);
      dispatch(slice.actions.updateCategoryProductSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function partialUpdateCategoryProduct(id, record) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.patch(`/category-product/${id}/`, record);
      dispatch(slice.actions.updateCategoryProductSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

// ----------------------------------------------------------------------

export function deleteCategoryProduct(id, restore = false) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`/category-product/${id}/`, { data: { restore } });
      dispatch(slice.actions.deleteCategoryProductSuccess({ id }));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

// ----------------------------------------------------------------------

export function actionHistoryCategoryProduct(id, data) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`/category-product/${id}/history/`, data);
      dispatch(slice.actions.updateCategoryProductSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}
